// extracted by mini-css-extract-plugin
export default {"arrow_icon":"S1_ManageLine_arrow_icon__MriY1","title_main":"S1_ManageLine_title_main__G7UTs","note":"S1_ManageLine_note__zfmFc"};